import { enqueueSnackbar } from "notistack";
import {   CTBRecords, CTBRequest, Job, JobData, ServerAPIResponse } from "../helpers/interfaces";
import { callServerAPI,  showBackDrop } from "../helpers/utils";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { isMapped } from "../helpers/constants";

const MySwal = withReactContent(Swal);


export const getAllCTBRecords = async (id: string) => {
    return await new Promise<CTBRecords[]>(async (resolve, reject) => {
        MySwal.fire(showBackDrop("Loading CTB Records"));
        callServerAPI<ServerAPIResponse<CTBRecords[]>>('GET', `/api/v1/CTB?CTBFetchHistoryId=${id}&PageSize=5000&OrderBy=ASCENDING&api-version=1`, null, true)
            .then(response => {
                MySwal.close()
                resolve(response.data.data)
            })
    })
}

export const getCTBRecords = async (mappingStatus:isMapped, recordsPerPage: Number, page: Number,  yearFilter:Number) => {
    return await new Promise<any>(async (resolve, reject) => {
        MySwal.fire(showBackDrop("Loading CTB Records"));
        callServerAPI<ServerAPIResponse<any>>('GET', `/api/v1/CTB?Page=${page}&PageSize=${recordsPerPage}&api-version=1&IsMapped=${mappingStatus}&year=${yearFilter}`, null, true)
            .then(response => {
                MySwal.close()
                resolve(response.data)       
            })
    })
}


export const getSAPCTBRecords = async (yearFilter:Number|undefined) => {
    return await new Promise<Job>(async (resolve, reject) => {
        MySwal.fire(showBackDrop("Loading CTB Records from SAP"));
        callServerAPI<Job>('GET', `/api/v1/CTB/FetchSAPCTB?api-version=1&year=${yearFilter}`, null, true)
            .then(response => {
               
                MySwal.close()
                

                resolve(response.data)
                
            })
    })
}
export const getJob = async (jobID:string) => {
    return await new Promise<JobData>(async (resolve, reject) => {
        MySwal.fire(showBackDrop("Loading..."));
        callServerAPI<ServerAPIResponse<JobData>>('GET', `/api/v1/Job?jobId=${jobID}&api-version=1`, null, true)
            .then(response => {
               
                MySwal.close()
                

                resolve(response.data.data)
                
            })
    })
}

export const fetchCTBRecordsHistory = async (recordsPerPage: Number, page: Number, ) => {
    return await new Promise<any>(async (resolve, reject) => {
        MySwal.fire(showBackDrop("Loading CTB Records History"));
        callServerAPI<ServerAPIResponse<any>>('GET', `/api/v1/CTB/GetCTBFetchHistory?OrderBy=ASCENDING&Page=${page}&PageSize=${recordsPerPage}&api-version=1`, null, true)
            .then(response => {
                MySwal.close()
                resolve(response.data)
            })
    })
}

export const UpdateCTBRecords = async (ctbRequestDto: CTBRequest[]) => {
    return await new Promise<CTBRequest[]>(async (resolve, reject) => {
        MySwal.fire(showBackDrop(" Mapping CTB Records "));
        callServerAPI<ServerAPIResponse<CTBRequest[]>>('PATCH', '/api/v1/CTB?api-version=1', {"ctbRequests":ctbRequestDto}, true)
            .then(response => {
                MySwal.close()
                enqueueSnackbar(" CTB Records Updated", { variant: 'success' });
                resolve(response.data.data)
            })
    })
}

export const exportExportUnmappedCTB = async (pageSize:Number, year: Number) => {
    return await new Promise<string>(async (resolve, reject) => {
        MySwal.fire(showBackDrop(" Exporting Unmapped CTB for Year " + year));
        callServerAPI<ServerAPIResponse<string>>('GET', `/api/v1/CTB/ExportUnmappedCTB?api-version=1&pageSize=${pageSize}&year=${year}`, null, true)
            .then(response => {
                MySwal.close()
                enqueueSnackbar(" Unmapped CTB Exported", { variant: 'success' });
                resolve(response.data.data)
            })
    })
}
export const exportExportAllUnmappedCTB = async (year: Number) => {
    return await new Promise<string>(async (resolve, reject) => {
        MySwal.fire(showBackDrop(" Exporting All Unmapped CTB for Year " + year));
        callServerAPI<ServerAPIResponse<string>>('GET', `/api/v1/CTB/ExportUnmappedCTB?api-version=1&year=${year}`, null, true)
            .then(response => {
                MySwal.close()
                enqueueSnackbar(" Unmapped CTB Exported", { variant: 'success' });
                resolve(response.data.data)
            })
    })
}
export const exportAllMappedCTB = async (year: Number) => {
    return await new Promise<string>(async (resolve, reject) => {
        MySwal.fire(showBackDrop(" Exporting All Mapped CTB "));
        callServerAPI<ServerAPIResponse<string>>('GET', `/api/v1/CTB/ExportMappedCTB?api-version=1&year=${year}`, null, true)
            .then(response => {
                MySwal.close()
                enqueueSnackbar(" Mapped CTB Exported", { variant: 'success' });
                resolve(response.data.data)
            })
    })
}
export const exportMappedCTB = async (pageSize:Number,year: Number) => {
    return await new Promise<string>(async (resolve, reject) => {
        MySwal.fire(showBackDrop(" Exporting Mapped CTB "));
        callServerAPI<ServerAPIResponse<string>>('GET', `/api/v1/CTB/ExportMappedCTB?api-version=1&pageSize=${pageSize}&year=${year}`, null, true)
            .then(response => {
                MySwal.close()
                enqueueSnackbar(" Mapped CTB Exported", { variant: 'success' });
                resolve(response.data.data)
            })
    })
}
export const uploadCBTRecordsExcelFile = async (formData: FormData, year:number) => {
    return await new Promise<Job>(async (resolve, reject) => {
        MySwal.fire(showBackDrop("Uploading CTB Records"));
        callServerAPI<Job>('POST', `/api/v1/CTB/ImportMappedCTB?&year=${year}&api-version=1`, formData, true)
            .then(response => {
                MySwal.close()
                
                resolve(response.data)
            })
    })
}